import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Button = styled(Link)`
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  gap: 5px;
  background: var(--success);
  padding: 7px 10px;
  margin-bottom: 10px;
  font-family: 'GothamBold';
  font-size: 1.4rem;
  color: #fff;
  cursor: pointer;
  text-transform: uppercase;
  transition: 0.3s;
  box-shadow: var(--box-shadow);
  &:hover {
    background: var(--success-hover);
  }
`;
